module.exports = __webpack_public_path__ + "img/rocketman-white.e3bd362e.svg";